/**
 * Logger condicional - Solo muestra logs en desarrollo
 * En producción, los logs son silenciados automáticamente
 */

const isDev = import.meta.env.DEV;

export const logger = {
  log: (...args: unknown[]) => {
    if (isDev) console.log(...args);
  },
  
  info: (...args: unknown[]) => {
    if (isDev) console.info('ℹ️', ...args);
  },
  
  warn: (...args: unknown[]) => {
    if (isDev) console.warn('⚠️', ...args);
  },
  
  error: (...args: unknown[]) => {
    // Errores siempre se muestran (importantes para debugging en producción)
    console.error('❌', ...args);
  },
  
  debug: (...args: unknown[]) => {
    if (isDev) console.debug('🔍', ...args);
  },
  
  // Para analytics y tracking
  track: (event: string, data?: unknown) => {
    if (isDev) console.log('📊', event, data);
  },
  
  // Para suscripciones y pagos
  payment: (message: string, data?: unknown) => {
    if (isDev) console.log('💳', message, data);
  },
  
  // Para tiempo real / realtime
  realtime: (message: string, data?: unknown) => {
    if (isDev) console.log('🔄', message, data);
  },
  
  // Para PWA
  pwa: (message: string, data?: unknown) => {
    if (isDev) console.log('📱', message, data);
  }
};

export default logger;
